export default __webpack_public_path__ + "static/media/Ballroll_00254.59ac41f0.png";